'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var logger={};if('undefined'!=typeof console)logger=console;else if('undefined'!=typeof window&&'undefined'!=typeof window.console)logger=window.console;else{var noop=function(){};logger={debug:noop,error:noop,info:noop,log:noop,warn:noop,trace:noop}}var log=logger;exports.default=log;
//# sourceMappingURL=logger.js.map


//////////////////
// WEBPACK FOOTER
// /builds/development/frontend/widgets/widgets/node_modules/@sm360/logger-sentry/dist/ConsoleLogger/logger.js
// module id = ../../node_modules/@sm360/logger-sentry/dist/ConsoleLogger/logger.js
// module chunks = widget-6.25.3